import { Deserializable } from '../../deserializable';

export class ExternalOfferApplicantDto implements Deserializable {
  public Id: number;
  public TitleCode: string;
  public FirstName: string;
  public LastName: string;
  public AcceptanceStatusCode: string;
  public LastActivityDate?: Date;
  public IsAccountHolder: boolean;
  public IsDirectDebitAcceptancePdfAvailable: boolean;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
